import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
export var Heading = function (_a) {
    var title = _a.title;
    return _jsx(Typography, { variant: "h3", children: title });
};
